module.exports = __webpack_public_path__ + "static/media/app-image-2.a8403884.png";